import { DEVELOPER_REALTY_USER_ID, DEVELOPER_REALTY_USER_ID_SPB } from 'shared/constants/developer';
import { LOCATION } from 'shared/settings/regions';

export function getUserIdByLocation(location: number): number {
  switch (location) {
    case LOCATION.SPB_AND_AREA.ID:
      return DEVELOPER_REALTY_USER_ID_SPB;
    default:
      return DEVELOPER_REALTY_USER_ID;
  }
}
